'use client'

import { useEffect, useRef } from 'react'
import { useAuthProvider } from '../providers/AuthProvider'

type SessionAction = (isSignedIn: boolean) => void

// Tag pages are served from the edge cache, so a visitor can tap before
// /auth/me answers. Rather than drop that tap or show a signed-in user the
// sign-in sheet, hold it and run it once the session is known. Only the latest
// held tap runs.
export function useAfterSessionCheck() {
  const { status } = useAuthProvider()
  const pendingRef = useRef<SessionAction | null>(null)

  useEffect(() => {
    if (status === 'loading' || !pendingRef.current) {
      return
    }

    const action = pendingRef.current
    pendingRef.current = null
    action(status === 'authenticated')
  }, [status])

  return function runAfterSessionCheck(action: SessionAction) {
    if (status === 'loading') {
      pendingRef.current = action

      return
    }

    action(status === 'authenticated')
  }
}
